import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/claim/rect.png'


const _withScopeId = n => (_pushScopeId("data-v-43d83e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-div",
  style: {"height":"100%","font-size":"50px"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "claim-wrap wrap breakdown_query--wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "rect"
  }),
  /*#__PURE__*/_createElementVNode("strong", { class: "wrap-title" }, "零售提交及校验情况")
], -1))
const _hoisted_5 = { class: "featureConBox" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "业务类型", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "品牌/车型", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "经销商所在区域", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "零售期间（年）", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "零售期间（季度/月份）", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "经销商名称（CN）", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, " ", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_14 = { class: "pageBtnBox featureConBox" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("图表展示")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_18 = { class: "table-box" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_chart_modal = _resolveComponent("chart-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.isEmpty)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " OASIS "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_Breadcrumb, { dataSource: [] }),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_space, {
            class: "feature-con",
            ref: "searchCon",
            align: "end"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_a_select, {
                      value: _ctx.bu,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bu) = $event)),
                      placeholder: "请选择",
                      allowClear: false,
                      class: "sel-inp-size",
                      onChange: _ctx.handleBuChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buList, (bu) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: bu.id,
                            value: bu.nameEn
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(bu.nameEn), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_a_select, {
                      value: _ctx.brand,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.brand) = $event)),
                      ref: "select",
                      placeholder: "请选择",
                      class: "sel-inp-size"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.brandNameEn,
                            key: item.id,
                            title: item.brandNameEn
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.brandNameEn), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "title"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createVNode(_component_a_select, {
                      allowClear: "",
                      value: _ctx.region,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.region) = $event)),
                      ref: "select",
                      disabled: _ctx.regionOnly,
                      placeholder: "请选择",
                      class: "sel-inp-size"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionList, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.regionId,
                            key: item.regionId,
                            title: item.regionEn
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.regionEn), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "title"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_a_date_picker, {
                      style: {"width":"100%"},
                      mode: "year",
                      valueFormat: "YYYY",
                      format: "YYYY",
                      value: _ctx.year,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.year) = $event)),
                      open: _ctx.openYear,
                      placeholder: "请选择",
                      onOpenChange: _ctx.handlerOpenChange,
                      onPanelChange: _ctx.handlerPanelChange
                    }, null, 8, ["value", "open", "onOpenChange", "onPanelChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createVNode(_component_a_tree_select, {
                      value: _ctx.qm,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.qm) = $event)),
                      style: {"width":"100%"},
                      "tree-data": _ctx.qmOptions,
                      "tree-checkable": "",
                      "allow-clear": "",
                      disabled: _ctx.qmDis,
                      "show-checked-strategy": _ctx.SHOW_PARENT,
                      "search-placeholder": "请选择",
                      placeholder: "请选择",
                      maxTagCount: 2
                    }, null, 8, ["value", "tree-data", "disabled", "show-checked-strategy"])
                  ]),
                  _: 1
                }),
                (_ctx.store.state.user.usrtpnm === 'Dealer Group')
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 0,
                      direction: "vertical",
                      style: {"margin-right":"15px","margin-bottom":"5px","width":"200px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createVNode(_component_a_input, {
                          value: _ctx.searchParams.dealerName,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParams.dealerName) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  style: {"margin-right":"15px","margin-bottom":"7px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createVNode(_component_a_button, { onClick: _ctx.resetClick }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.$btnPermissions('RVD001'))
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 0,
                      direction: "vertical",
                      style: {"margin-right":"15px","margin-bottom":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { onClick: _ctx.openDownload }, {
                          default: _withCtx(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('RVD002'))
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 1,
                      direction: "vertical",
                      style: {"margin-right":"15px","margin-bottom":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, { onClick: _ctx.openChart }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$btnPermissions('RVD003'))
                  ? (_openBlock(), _createBlock(_component_a_space, {
                      key: 2,
                      direction: "vertical",
                      style: {"margin-right":"15px","margin-bottom":"5px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _ctx.searchClick,
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 512),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_a_table, {
              class: "ant-table-striped",
              rowKey: "dealerConficoCode",
              columns: _ctx.columns,
              "data-source": _ctx.tableData,
              pagination: false,
              scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
              rowClassName: 
            (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          
            }, {
              eligibleRetailNo: _withCtx(({ text }) => [
                (_ctx.isDealer)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.routerJump && _ctx.routerJump(...args))),
                      style: {"text-decoration":"underline"}
                    }, _toDisplayString(text), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(text), 1))
              ]),
              _: 1
            }, 8, ["columns", "data-source", "scroll", "rowClassName"])
          ]),
          _createVNode(_component_chart_modal, {
            modalVisible: _ctx.chartVisible,
            "onUpdate:modalVisible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.chartVisible) = $event)),
            params: _ctx.searchParams,
            onCloseModal: _ctx.closeChart
          }, null, 8, ["modalVisible", "params", "onCloseModal"]),
          _createVNode(_component_a_modal, {
            visible: _ctx.downloadVisible,
            title: "下载",
            onCancel: _ctx.closeDownload
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                key: "back",
                onClick: _ctx.closeDownload
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                key: "submit",
                type: "primary",
                onClick: _ctx.downloadClick
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                "row-selection": _ctx.downloadRowSelection,
                columns: _ctx.downloadColumnsData,
                pagination: false,
                dataSource: _ctx.downloadTableData,
                rowKey: "fileType"
              }, null, 8, ["row-selection", "columns", "dataSource"])
            ]),
            _: 1
          }, 8, ["visible", "onCancel"])
        ])
      ]))
}